type Key = string | number;

export interface Node<T>
{
    parent?: Node<T>;
    value: T;
    children: Node<T>[];
}

export class Forest<T>
{
    private readonly roots: Node<T>[] = [];
    private readonly map: Map<Key, Node<T>> = new Map();
    
    constructor(private key: (item: T) => Key, private parentKey: (item: T) => Key, items: T[])
    {
        items.forEach(item => this.map.set(key(item), { value: item, children: [] }));
        const visited = new Set<Key>();

        items.forEach(item => {
            let cur = this.map.get(key(item));
            while(cur) {
                if(visited.has(key(cur.value)))
                    break;
                visited.add(key(cur.value));

                const parent = this.map.get(parentKey(cur.value));
                cur.parent = parent;
                if(parent)
                    parent.children.push(cur);
                else
                    this.roots.push(cur);
                cur = parent;
            }
        });
    }

    getByKey = (key: Key): Node<T> => {
        return this.map.get(key);
    }

    getRoots = () => {
        return this.roots.slice(0);
    }
}

export const selfAndAncestors = <T>(node: Node<T>): T[] => {
    const result: T[] = [];
    let cur = node;
    while(cur) {
        result.push(cur.value);
        cur = cur.parent;
    }
    return result;
}


// WEBPACK FOOTER //
// ./src/utils/Forest.ts